/**
 * Marketing / Playwright capture mode: `?screenshot=1` hides FABs and other
 * fixed chrome so listing screenshots stay clean.
 */
export function isScreenshotMode(): boolean {
  if (typeof window === "undefined") return false;
  return new URLSearchParams(window.location.search).get("screenshot") === "1";
}

/** Apply `screenshot-mode` on <html> as early as possible. */
export function applyScreenshotModeClass(): void {
  if (typeof document === "undefined") return;
  if (isScreenshotMode()) {
    document.documentElement.classList.add("screenshot-mode");
  } else {
    document.documentElement.classList.remove("screenshot-mode");
  }
}
